import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to /BTC-USDT as soon as component mounts
    navigate('/BTC-USDT', { replace: true });
  }, [navigate]);

  return (
    <div>
      {/* Optional: Loading state or nothing, since it redirects instantly */}
      Redirecting...
    </div>
  );
}
